'use client';

import { useRef } from 'react';
import { motion, useScroll, useTransform, useSpring } from 'framer-motion';

import Reveal from 'components/ui/Reveal';
import peanutCloseup from '../../images/product/ProductImgOpen.webp';

export default function ProductStory() {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"]
  });

  const rawY = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);
  const yParallax = useSpring(rawY, { stiffness: 90, damping: 25, restDelta: 0.001 });

  return (
    <section ref={containerRef} className="py-12 sm:py-16 md:py-20 lg:py-24 bg-singaraa-cream overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-20">
        <div className="flex flex-col md:flex-row items-center gap-0 sm:gap-0 md:gap-0 lg:gap-10">

          {/* Text Content */}
          <div className="w-full md:w-1/2">
            <Reveal>
              <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-singaraa-brown font-bold mb-4 sm:mb-6 leading-tight">
                Simple Ingredient. <br />
                <span className="text-singaraa-caramel">Richer Experience.</span>
              </h2>
            </Reveal>

            <Reveal delay={0.1}>
              <p className="font-body text-sm sm:text-base md:text-lg text-singaraa-dark/80 mb-4 sm:mb-6 leading-relaxed">
                Peanuts have always been a staple in Indian culture - a companion for long train journeys, a crunchy addition to evening tea, and a simple joy shared among family and friends. At Singaraa, we honor this tradition by elevating the humble peanut.
              </p>
            </Reveal>

            <Reveal delay={0.2}>
              <p className="font-body text-sm sm:text-base md:text-lg text-singaraa-dark/80 leading-relaxed">
                Through our careful dry-roasting process, we lock in the natural protein and enhance the innate nutty flavor without unnecessary frying. The result is a premium snack that transforms a simple ingredient into a richer, crunchier experience.
              </p>
            </Reveal>
          </div>

          {/* Image Parallax Area */}
          <div className="w-full md:w-1/2 relative flex items-center justify-center h-[280px] sm:h-[380px] md:h-[500px]">
            <motion.div
              className="relative w-full h-full"
              style={{ y: yParallax }}
            >
              <img
                src={peanutCloseup}
                alt="Close up of premium Singaraa dry roasted peanuts"
                className="w-full h-full object-contain drop-shadow-2xl"
              />
            </motion.div>
          </div>

        </div>
      </div>
    </section>
  );
}
